import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';

export const CurrentTag: StyleRule = () => ({
    [`&.${buttonClassName}`]: {
        position: 'absolute',
    },
});

/**
 * Wrapper for the new-tag placement icon. Applies a `drop-shadow` filter for contrast on bright
 * photos; the shadow follows the tag glyph's painted bounds.
 */
export const TagIconOnPhoto: StyleRule = () => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.35))',
});

export const SearchModalContainer: StyleRule = ({ theme }) => ({
    zIndex: theme.siteVariables.zIndexes.menuItem + 1, // make sure it's above the resene menu
});
